import moment from "moment";

export const shuffleNumArray = (arrayLength: number) => {
  return Array.from(Array(arrayLength).keys()).sort(() => Math.random() - 0.5);
};

export const getDateTime = () => {
  const dateTime = `${moment(new Date()).utc().format("YYYY.MM.DD,HH:mm:ss")}`;
  return dateTime;
};

export const shuffleArray = (array: any) => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
};

export const getAnswerFromVideo = (video: string) => {
  if (video.indexOf("ang") > -1) {
    return "anger";
  }
  if (video.indexOf("con") > -1) {
    return "contempt";
  }
  if (video.indexOf("dis") > -1) {
    return "disgust";
  }
  if (video.indexOf("fea") > -1) {
    return "fear";
  }
  if (video.indexOf("hap") > -1) {
    return "happiness";
  }
  if (video.indexOf("neu") > -1) {
    return "neutral";
  }
  if (video.indexOf("sad") > -1) {
    return "sadness";
  }
  if (video.indexOf("sur") > -1) {
    return "surprise";
  }
};

export const makeProblems = (array: string[]) => {
  let problems: any = [];
  array.forEach((item) => {
    const problem = { video: item, answer: getAnswerFromVideo(item) };
    problems.push(problem);
  });
  return problems;
};

export const getAnswerFromVideo2 = (video: string) => {
  let answers = [];
  if (video.indexOf("ang") > -1) {
    answers.push("anger");
  }
  if (video.indexOf("con") > -1) {
    answers.push("contempt");
  }
  if (video.indexOf("dis") > -1) {
    answers.push("disgust");
  }
  if (video.indexOf("fea") > -1) {
    answers.push("fear");
  }
  if (video.indexOf("hap") > -1) {
    answers.push("happiness");
  }
  if (video.indexOf("neu") > -1) {
    answers.push("neutral");
  }
  if (video.indexOf("sad") > -1) {
    answers.push("sadness");
  }
  if (video.indexOf("sur") > -1) {
    answers.push("surprise");
  }
  return answers;
};

export const makeProblems2 = (array: string[]) => {
  let problems: any = [];
  array.forEach((item) => {
    const problem = { video: item, answer: getAnswerFromVideo2(item) };
    problems.push(problem);
  });
  return problems;
};
